<template>
  <span class="wco">
    <select :value="mode" class="wco-input wco-mode" @change="setMode($event.target.value)">
      <option v-if="optional" value="none">(none)</option>
      <option value="col">column</option>
      <option value="value">value</option>
      <option v-if="allowToday" value="today">today</option>
    </select>
    <select v-if="mode === 'col'" :value="modelValue.col" class="wco-input wco-mono" @change="$emit('update:modelValue', { col: $event.target.value })">
      <option v-for="c in columns" :key="c" :value="c">{{ c }}</option>
    </select>
    <input v-else-if="mode === 'value'" :value="modelValue.value" class="wco-input" placeholder="value" @input="setValue($event.target.value)" />
  </span>
</template>

<script>
export default {
  name: 'WorkflowCalcOperand',
  props: {
    modelValue: { type: Object, default: null },
    columns: { type: Array, default: () => [] },
    allowToday: { type: Boolean, default: false },
    optional: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    mode() {
      const v = this.modelValue;
      if (!v) return 'none';
      if (v.today) return 'today';
      return 'col' in v ? 'col' : 'value';
    },
  },
  methods: {
    setMode(mode) {
      const next = { none: null, today: { today: true }, col: { col: this.columns[0] }, value: { value: '' } }[mode];
      this.$emit('update:modelValue', next);
    },
    setValue(raw) {
      const n = Number(raw);
      this.$emit('update:modelValue', { value: raw !== '' && !Number.isNaN(n) ? n : raw });
    },
  },
};
</script>

<style scoped>
.wco { display: inline-flex; gap: 4px; width: 100%; }
.wco-input { box-sizing: border-box; border: 1px solid #e5e7eb; border-radius: 6px; padding: 3px 7px; font-size: 11.5px; color: #1f2937; background: #fff; min-width: 0; }
.wco-input:focus { outline: none; border-color: var(--color-accent, #0E8C9E); }
.wco-input:last-child { flex: 1; }
.wco-mode { width: 74px; flex-shrink: 0; flex: none; }
.wco-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
</style>
